
    import * as React from 'react';

    const ChevronLeft20 = ({ color = 'currentcolor', height = '20px', width = '20px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 20 20" xmlnsXlink="http://www.w3.org/1999/xlink" style={svgStyle}><g stroke="none" strokeWidth={1} fillRule="evenodd"><polygon fillRule="nonzero" points="14.450825 3.008883 13.566942 2.125000 5.625000 10.066942 13.566942 18.008883 14.450825 17.125000 7.392767 10.066942" /></g></svg>
        </div>
      );
    };

    ChevronLeft20.displayName = 'ChevronLeft20';

    export default ChevronLeft20;
  